import { RootState } from '../store';

export const authSelector = (state: RootState) => state.auth;
export const profileSelector = (state: RootState) => state.auth.profile;
export const checkingAuthSelector = (state: RootState) => state.auth.checkAuth;
